module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "To Confirm",
      "name": "first"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Tracking or UPC",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getToConfirmTrackingList.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.filters.toConfirmFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "toConfirmFilter", $$v)
      },
      expression: "filters.toConfirmFilter"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getToConfirmTrackingList
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showImport
    }
  }, [_vm._v("Import")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showBulkConfirm
    }
  }, [_vm._v("Bulk Confirm")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showBulkRemove
    }
  }, [_vm._v("Bulk Remove")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportExcel('/excel/exportWarehouseTracking', 'Tracking.xls', 1)
      }
    }
  }, [_vm._v("Export")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.firstListLoading),
      expression: "firstListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.toConfirmList,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "batchNumber",
      "label": "Batch Number"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tracking",
      "label": "Tracking #"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v(_vm._s(scope.row.tracking))]), _vm._v(" "), _c('p', {
          staticClass: "note"
        }, [_vm._v(_vm._s(scope.row.note))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "upc",
      "label": "UPC"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "qty",
      "label": "Qty",
      "width": "100px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Warehouse"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isDoctor == 0) ? _c('p', [_c('i', {
          staticClass: "fa fa-university"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e(), _vm._v(" "), (scope.row.isDoctor == 1) ? _c('p', [_c('i', {
          staticClass: "fa fa-user"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createDate",
      "label": "Import Date"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isMixedPackage === 1) ? _c('div', [_c('el-tag', {
          attrs: {
            "type": "info"
          }
        }, [_vm._v("Mixed Package")])], 1) : _c('div', [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.showEdit(scope.row.cwId)
            }
          }
        }, [_vm._v("Edit\n\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.removeTracking(scope.row.cwId)
            }
          }
        }, [_vm._v("Remove")])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.toConfirmTotal
    },
    on: {
      "current-change": _vm.changeConfirmPage
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Inbound History",
      "name": "second"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Name、Tracking or UPC",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getHistoryList.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.filters.historyFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "historyFilter", $$v)
      },
      expression: "filters.historyFilter"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getHistoryList
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showBulkReverse
    }
  }, [_vm._v("Bulk Reverse")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportExcel('/excel/exportWarehouseInboundHistory', 'inboundHistory.xls', 3)
      }
    }
  }, [_vm._v("Export")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.goToMixedPackage
    }
  }, [_vm._v("Mixed Package")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.secondListLoading),
      expression: "secondListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.inboundHistory,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "#",
      "prop": "cwId"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "Shared warehouse inbound"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(scope.row.productName) + " (" + _vm._s(scope.row.lastUpdateDate) + ")\n\t\t\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tracking",
      "label": "Tracking"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "company",
      "label": "Company"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Warehouse"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isDoctor == 0) ? _c('p', [_c('i', {
          staticClass: "fa fa-university"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e(), _vm._v(" "), (scope.row.isDoctor == 1) ? _c('p', [_c('i', {
          staticClass: "fa fa-user"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "nurseName",
      "label": "User"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "qty",
      "label": "Qty"
    }
  }), _vm._v(" "), (_vm.user.userNo == 'user-9aa177023c4340609ce337d618d0bd99' || _vm.user.userNo == 'user-bcfde657d5684dd694d89ae424f11530') ? _c('el-table-column', {
    attrs: {
      "prop": "forceChargeTime",
      "label": "Force Charge Time"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productStatus",
      "label": "productStatus"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!_vm.isMixedPackageRecord(scope.row)) ? _c('el-button', {
          attrs: {
            "size": "small",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.editInboundHistory(scope.row)
            }
          }
        }, [_vm._v("Edit\n\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (!_vm.isMixedPackageRecord(scope.row) && scope.row.productStatus && scope.row.productStatus.indexOf('Can be reverse') !== -1) ? _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.reverseById(scope.row.cwId)
            }
          }
        }, [_vm._v("\n\t\t\t\t\t\t\t\tReverse\n\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.isMixedPackageRecord(scope.row)) ? _c('el-tooltip', {
          attrs: {
            "content": "混寄包裹记录不支持在此处编辑或撤销，请在混寄包裹管理界面操作",
            "placement": "top"
          }
        }, [_c('span', {
          staticStyle: {
            "color": "#909399",
            "font-size": "12px"
          }
        }, [_c('i', {
          staticClass: "el-icon-info"
        }), _vm._v(" Mixed Package Record\n\t\t\t\t\t\t\t\t")])]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.historyTotal
    },
    on: {
      "current-change": _vm.changeHistoryList
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Edit Inbound",
      "width": "80%",
      "visible": _vm.editToConfirmInboundVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editToConfirmInboundVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "editTracking",
    attrs: {
      "model": _vm.editTracking,
      "label-width": "220px",
      "rules": _vm.editRule
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Warehouse",
      "prop": "warehouseNo"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editTracking.warehouseNo),
      callback: function($$v) {
        _vm.$set(_vm.editTracking, "warehouseNo", $$v)
      },
      expression: "editTracking.warehouseNo"
    }
  }, _vm._l((_vm.warehouses), function(warehouse, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": warehouse.warehouseNo,
        "label": warehouse.state + ' ' + warehouse.city + ' ' + warehouse.address
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tracking Number",
      "prop": "trackingNumber"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editTracking.trackingNumber),
      callback: function($$v) {
        _vm.$set(_vm.editTracking, "trackingNumber", $$v)
      },
      expression: "editTracking.trackingNumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "UPC",
      "prop": "upc"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editTracking.upc),
      callback: function($$v) {
        _vm.$set(_vm.editTracking, "upc", $$v)
      },
      expression: "editTracking.upc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Qty",
      "prop": "qty"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editTracking.qty),
      callback: function($$v) {
        _vm.$set(_vm.editTracking, "qty", $$v)
      },
      expression: "editTracking.qty"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Note",
      "prop": "note"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": "5",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editTracking.note),
      callback: function($$v) {
        _vm.$set(_vm.editTracking, "note", $$v)
      },
      expression: "editTracking.note"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editToConfirmInboundVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleEdit.apply(null, arguments)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Edit Inbound",
      "width": "80%",
      "visible": _vm.editInboundHistoryVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editInboundHistoryVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "editInbound",
    attrs: {
      "model": _vm.editInbound,
      "label-width": "220px",
      "rules": _vm.editRule
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Product Name"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editInbound.productName),
      callback: function($$v) {
        _vm.$set(_vm.editInbound, "productName", $$v)
      },
      expression: "editInbound.productName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Company"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editInbound.company),
      callback: function($$v) {
        _vm.$set(_vm.editInbound, "company", $$v)
      },
      expression: "editInbound.company"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tracking Number"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editInbound.tracking),
      callback: function($$v) {
        _vm.$set(_vm.editInbound, "tracking", $$v)
      },
      expression: "editInbound.tracking"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "UPC"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editInbound.upc),
      callback: function($$v) {
        _vm.$set(_vm.editInbound, "upc", $$v)
      },
      expression: "editInbound.upc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Warehouse"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editInbound.warehouse),
      callback: function($$v) {
        _vm.$set(_vm.editInbound, "warehouse", $$v)
      },
      expression: "editInbound.warehouse"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Qty"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editInbound.qty),
      callback: function($$v) {
        _vm.$set(_vm.editInbound, "qty", $$v)
      },
      expression: "editInbound.qty"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Note"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editInbound.note),
      callback: function($$v) {
        _vm.$set(_vm.editInbound, "note", $$v)
      },
      expression: "editInbound.note"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editInboundHistoryVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editConfirmedTracking.apply(null, arguments)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Import",
      "width": "80%",
      "visible": _vm.warehouseImportVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.warehouseImportVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "importTrack",
    attrs: {
      "model": _vm.importTrack,
      "label-width": "220px",
      "rules": _vm.importRule
    }
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.removeAllItem.apply(null, arguments)
      }
    }
  }, [_vm._v("Remove All Tracking")]), _vm._v(" "), _c('el-button', {
    staticClass: "pull-right",
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.importTracking.apply(null, arguments)
      }
    }
  }, [_vm._v("Submit")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Batch number",
      "prop": "batchNumber"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "auto-complete": "off",
      "value": _vm.batchNumber
    },
    model: {
      value: (_vm.importTrack.batchNumber),
      callback: function($$v) {
        _vm.$set(_vm.importTrack, "batchNumber", $$v)
      },
      expression: "importTrack.batchNumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Warehouse",
      "prop": "warehouseNo"
    }
  }, [_c('el-select', {
    attrs: {
      "auto-complete": "off",
      "clearable": ""
    },
    model: {
      value: (_vm.importTrack.warehouseNo),
      callback: function($$v) {
        _vm.$set(_vm.importTrack, "warehouseNo", $$v)
      },
      expression: "importTrack.warehouseNo"
    }
  }, _vm._l((_vm.warehouses), function(warehouse, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": warehouse.warehouseNo,
        "label": warehouse.state + ' ' + warehouse.city + ' ' + warehouse.address
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tracking Number",
      "prop": "trackingNumbers"
    }
  }, [(_vm.importTrack.trackingNumbers.length > 0) ? _c('div', [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.importTrack.trackingNumbers,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tracking",
      "label": "Tracking Number"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "upc",
      "label": "UPC"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "qty",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "note",
      "label": "Note"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.removeRow(scope.row)
            }
          }
        }, [_vm._v("Remove\n\t\t\t\t\t\t\t\t\t")])]
      }
    }], null, false, 3656174827)
  })], 1)], 1) : _c('div', [_c('p', {
    staticStyle: {
      "padding": "0",
      "margin": "0",
      "font-size": "18px",
      "color": "#11b95c"
    }
  }, [_vm._v("You have not uploaded tracking\n\t\t\t\t\t\t\tnumber, please upload tracking number.")])]), _vm._v(" "), _c('p', [_vm._v("Import tracking number as\n\t\t\t\t\t\t"), _c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.textImportVisible = true
      }
    }
  }, [_vm._v("Text")]), _vm._v("\n\t\t\t\t\t\tor\n\t\t\t\t\t\t"), _c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.excelImportVisible = true
      }
    }
  }, [_vm._v("Excel")])], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.warehouseImportVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.removeAllItem.apply(null, arguments)
      }
    }
  }, [_vm._v("Remove All Tracking")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.importTracking.apply(null, arguments)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Bulk confirm shared warehouse inbound items",
      "width": "80%",
      "visible": _vm.bulkConfirmVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.bulkConfirmVisible = $event
      }
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "label": "Batch Number :"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select a batch number",
      "clearable": "",
      "filterable": ""
    },
    on: {
      "change": _vm.changeBatchNumberForBulkConfirm
    },
    model: {
      value: (_vm.batchNumber),
      callback: function($$v) {
        _vm.batchNumber = $$v
      },
      expression: "batchNumber"
    }
  }, _vm._l((_vm.batchNumbers), function(b, i) {
    return _c('el-option', {
      key: i,
      attrs: {
        "value": b,
        "label": b
      }
    })
  }), 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.sendMail
    }
  }, [_vm._v("Send Email")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.bulkConfirmList,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "upc",
      "label": "UPC"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "qty",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "company",
      "label": "Company"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Product"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          attrs: {
            "placeholder": "select a product"
          },
          model: {
            value: (scope.row.productNo),
            callback: function($$v) {
              _vm.$set(scope.row, "productNo", $$v)
            },
            expression: "scope.row.productNo"
          }
        }, _vm._l((scope.row.productsList), function(p, i) {
          return _c('el-option', {
            key: i,
            attrs: {
              "label": p.productName,
              "value": p.productNo
            }
          })
        }), 1)]
      }
    }])
  }), _vm._v(" "), (_vm.user.userNo == 'user-9aa177023c4340609ce337d618d0bd99' || _vm.user.userNo == 'user-bcfde657d5684dd694d89ae424f11530') ? _c('el-table-column', {
    attrs: {
      "label": "Force Charge Time"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-date-picker', {
          attrs: {
            "value-format": "yyyy-MM-dd",
            "type": "date",
            "placeholder": "Force Charge Time"
          },
          model: {
            value: (scope.row.forceChargeTime),
            callback: function($$v) {
              _vm.$set(scope.row, "forceChargeTime", $$v)
            },
            expression: "scope.row.forceChargeTime"
          }
        })]
      }
    }], null, false, 403668256)
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.removeItem(scope.row)
            }
          }
        }, [_vm._v("Remove")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.bulkConfirm.apply(null, arguments)
      }
    }
  }, [_vm._v("Bulk Confirm")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Bulk remove shared warehouse inbound items",
      "width": "80%",
      "visible": _vm.bulkRemoveVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.bulkRemoveVisible = $event
      }
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "label": "Batch Number :"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select a batch number",
      "clearable": "",
      "filterable": ""
    },
    on: {
      "change": _vm.changeBatchNumberForBulkRemove
    },
    model: {
      value: (_vm.batchNumber),
      callback: function($$v) {
        _vm.batchNumber = $$v
      },
      expression: "batchNumber"
    }
  }, _vm._l((_vm.batchNumbers), function(b, i) {
    return _c('el-option', {
      key: i,
      attrs: {
        "value": b,
        "label": b
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.bulkRemoveList,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tracking",
      "label": "Tracking #"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "upc",
      "label": "UPC"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "qty",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "company",
      "label": "Company"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "danger",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.bulkRemove.apply(null, arguments)
      }
    }
  }, [_vm._v("Bulk Remove")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Bulk reverse",
      "width": "80%",
      "visible": _vm.bulkReverseVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.bulkReverseVisible = $event
      }
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "label": "Batch Number :"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select a batch number",
      "clearable": "",
      "filterable": ""
    },
    on: {
      "change": _vm.changeBatchNumberForBulkReverse
    },
    model: {
      value: (_vm.batchNumber),
      callback: function($$v) {
        _vm.batchNumber = $$v
      },
      expression: "batchNumber"
    }
  }, _vm._l((_vm.batchNumbers), function(b, i) {
    return _c('el-option', {
      key: i,
      attrs: {
        "value": b,
        "label": b
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.bulkReverseList,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Shared warehouse inbound"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t" + _vm._s(scope.row.productName) + " (" + _vm._s(scope.row.lastUpdateDate) + ")\n\t\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "upc",
      "label": "UPC"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "qty",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tracking",
      "label": "Tracking"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "company",
      "label": "Company"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "warehouse",
      "label": "Warehouse"
    }
  }), _vm._v(" "), (_vm.user.userNo == 'user-9aa177023c4340609ce337d618d0bd99' || _vm.user.userNo == 'user-bcfde657d5684dd694d89ae424f11530') ? _c('el-table-column', {
    attrs: {
      "prop": "forceChargeTime",
      "label": "Force Charge Time"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "danger",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.bulkReverse.apply(null, arguments)
      }
    }
  }, [_vm._v("Bulk Reverse")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Import tracking number from text",
      "width": "80%",
      "visible": _vm.textImportVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.textImportVisible = $event
      }
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": "10",
      "placeholder": _vm.placeholder,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.text),
      callback: function($$v) {
        _vm.text = $$v
      },
      expression: "text"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_vm._v("The tracking number import of text needs to contain tracking Numbers, upc, quantity, note,\n\t\t\t\tseparated by commas,space or tab, and multiple records must be separated by newline.")]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.textImportVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.importFromText.apply(null, arguments)
      }
    }
  }, [_vm._v("Import")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Import tracking number from excel",
      "width": "80%",
      "visible": _vm.excelImportVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.excelImportVisible = $event
      }
    }
  }, [_c('el-upload', {
    ref: "upload",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "on-success": _vm.uploadSuccess,
      "on-error": _vm.uploadError,
      "name": "filename",
      "drag": "",
      "action": _vm.uploadUrl,
      "headers": _vm.headers,
      "limit": 1,
      "accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_c('em', [_vm._v("click to upload")]), _vm._v(" or drag and drop file")]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("Only allowed .xls,.xlsx files, please follow the columns format with trackingNum,upc,quantity,note, include the header.")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5de49af1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/warehouseAdmin/Inbound.vue
// module id = 830
// module chunks = 1